<template>
    <div class="master-template-select-view-control multiselect-view-control">
        <Button :class="{ active: view === MultiviewMode.Grid }" @click="switchView(MultiviewMode.Grid)">
            <Icon type="md-apps" />
        </Button>
        <Button :class="{ active: view === MultiviewMode.List }" @click="switchView(MultiviewMode.List)">
            <Icon type="md-list" />
        </Button>
    </div>
</template>

<script lang="ts">
import { MultiviewMode } from "@/enums/multiview.ts";
import { MasterTemplateLibraryAction } from "@/store/modules/masterTemplateLibrary";

export default {
    name: "MasterTemplateSelectViewControl",

    data() {
        return {
            MultiviewMode
        };
    },

    computed: {
        view() {
            return this.$store.state.masterTemplateLibrary.selectViewMode;
        }
    },

    methods: {
        switchView(view: (typeof MultiviewMode)[keyof typeof MultiviewMode]) {
            this.$store.dispatch(MasterTemplateLibraryAction.SetSelectViewMode, view);
        }
    }
};
</script>

<style lang="scss">
@use "@style/variables" as *;

.multiselect-view-control {
    display: flex;
    flex-wrap: nowrap;

    .active {
        z-index: 1;
    }

    .ivu-btn:first-child {
        border-bottom-right-radius: 0;
        border-top-right-radius: 0;
        margin-right: -1px;
    }

    .ivu-btn:last-child {
        border-bottom-left-radius: 0;
        border-top-left-radius: 0;
    }
}

.master-template-select-view-control {
    margin-right: $spacing;
}
</style>
